import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteBesichtigungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteBesichtigungCommandService],
  exports: []
})
export class DeleteBesichtigungCommandServiceModule { }
